<template>
  <b-form>
    <b-form-group>
      <div class="d-flex align-items-center">
        <span class="label-type-2 mr-2">Homepage Customer Notes</span>
        <switches
          v-model="selectedValue.enable"
          @input="$root.$emit('changesDetected')"
          theme="custom"
          color="primary"
          type-bold="true"
          style="top: 12px"
          :emit-on-mount="false"
          disabled
        />
        <span class="ml-2">
          <small class="text-muted">{{
            `${selectedValue.enable ? "Enabled" : "Disabled"}`
          }} (Coming Soon)</small>
        </span>
      </div>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col md="8">
          <div class="info d-flex align-items-center">
            <img
              src="@/assets/images/icons/blue-filled-rounded-i.png"
              alt="Information"
              class="h-100"
            />
            <span class="ml-2">Can be a section to allow Merchants to indicate details for free delivery or dates when they will not be accepting orders.</span>
          </div>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col md="8">
          <b-form-input
            v-model="selectedValue.message"
            :maxlength="messageMaxLength"
            @input="$root.$emit('changesDetected')"
            :disabled="!selectedValue.enable"
            :state="isInvalid('homepage_notes.message')"
            @keypress="onKeypressFilter"
            trim>
          </b-form-input>
          <div class="char-count">
            {{ selectedValue.message ? selectedValue.message.length : 0 }} /
            {{ messageMaxLength }}
          </div>
          <b-form-invalid-feedback :force-show="isInvalid('homepage_notes.message')">
            {{ errorMessage('homepage_notes.message') }}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </b-form-group>
  </b-form>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import Switches from "vue-switches";

export default {
  name: 'FulfillmentHomepageNotes',
  props: ['selectedValue'],
  components: { Switches },
  data() {
    return {
      messageMaxLength: 300
    }
  },
  computed: {
    ...mapGetters({
      errors: 'orderFulfillment/errors'
    })
  },
  methods: {
    ...mapMutations({
      setErrors: "orderFulfillment/set_errors",
    }),
    isInvalid(key) {
      return this.errors && this.errors[key] ? false : null;
    },
    errorMessage(key) {
      return this.errors && this.errors[key] ? this.errors[key] : null;
    },
    onKeypressFilter(e) {
      if (/[^a-z0-9;!:.()\-_&*',\s]/i.test(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
  },
}
</script>

<style lang="scss" scoped>
.char-count {
  margin-top: 5px;
  text-align: right;
  font-size: 11px;
  color: #6c757d;
}
.info {
  padding: 3px 10px;
  background: #f8f9f9;
  border-radius: 5px;
  width: fit-content;
  span {
    font-size: 12px;
  }
}
</style>
